/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { date, DateFormat, entity } from '@gh/core-data';
import { JobInsuranceDto } from './job-insurance.dto';

export const JobInsuranceMapper = entity<JobInsuranceDto>({
  insuranceStartDate: date(DateFormat.Date),
});
